define([
	"dojo/_base/declare",
	"lodash",
	"csi/comm/PostRequest",
	"csi/utility/htmlUtility",
	"csi/xml",
	"./EmailController"
], function(declare, _, PostRequest, {purifyForHtml}, xml, EmailController) {

	return declare(EmailController, {
		allowArbitraryEmailAddresses: false,

		getInitialValues: function() {
			// summary: get initial values for Email form
			const initialValues = this.inherited(arguments);
			const pageTitle = document.title;
			const pageUrl = location.href;

			const req = new PostRequest("SiteAdmin", "GetTemplatedEmailSubjectAndBody", {
				TemplateName: "Page Link",
				TemplateSubtype: "AdHoc",
				PageTitle: pageTitle,
				URL: pageUrl
			});

			return req.go().then((response) => {
				const result = response.getResultNode();
				const subject = result.Subject || pageTitle;
				const body = result.Body || `<br/><a href='${pageUrl}'>${pageTitle}</a><br/>`;

				initialValues.subject = subject;
				initialValues.message = purifyForHtml(body + initialValues.message);

				return initialValues;
			});
		},

		preProcess: function() {
			this.inherited(arguments);

			// Arbitrary emails are not allowed in NavBar's email;
			this.dialog.form.toUsersNode.selectNode.addNewItem = false;
			this.dialog.form.ccUsersNode.selectNode.addNewItem = false;
			this.dialog.form.bccUsersNode.selectNode.addNewItem = false;
		},

		_processResultNode: function(/*Node*/node, /*Cache*/cache) {
			// summary: convert a node into an item for 'Names' store
			var res = this.inherited(arguments);

			if (node.$Type == "ContactList") {
				return null; // ContactLists are not allowed in NavBar's email;
			} else {
				return res;
			}
		},

		toWriter: function() {
			// summary: set values to email message
			// overrides base implementation on EmailController, which sets users
			// as stringlist which doesn't map well to this implementation (needs to use reflist)
			var call = this.m_writer.callMethod("SiteAdmin", "EmailPageLink");

			call.addParameter("SendTo", xml.ATTR_REFLIST, this._values.toUsers);
			call.addParameter("CCTo", xml.ATTR_REFLIST, this._values.ccUsers);
			call.addParameter("BCCTo", xml.ATTR_REFLIST, this._values.bccUsers);

			call.addParameter("Subject", xml.ATTR_STRING, this._values.subject);

			call.addParameter("Text", xml.ATTR_STRING, this.prepareMessageBody());

			return call;
		}
	});
});